module.exports = __webpack_public_path__ + "static/media/locationActive.ae3796b0.svg";